var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loco-badge"},[_c('div',{staticClass:"loco-badge__label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{staticClass:"loco-badge__icon"},[_vm._t("icon")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }